import { render } from "./CrudArtEngenheiroTransportador.vue?vue&type=template&id=2e4a2b58"
import script from "./CrudArtEngenheiroTransportador.vue?vue&type=script&lang=ts"
export * from "./CrudArtEngenheiroTransportador.vue?vue&type=script&lang=ts"
script.render = render

export default script